module.exports = {
  // 详情页的内容
  titleCardOptions: {
    titles: [
      { name: '服务详情', id: 'detail' },
      { name: '服务案例', id: 'example' }
    ],
    selectedLabel: 'detail',
    showMore: false,
    isSwitch: true
  }
}